import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Purchasing module service stores — starter Purchasing module backing the
 * /purchasing route. Four services, all backed by Premier-specific tables
 * (NOT the accounting `purchase_orders` / `vendors` master records):
 *
 *   purchasing-orders            → Orders WIP grid + Historical Log tabs
 *   purchasing-order-attachments → Order Detail drawer document sections
 *   purchasing-scratchpads       → Per-Job Scratchpad tab
 *   purchasing-vendor-notes      → Vendor Reference / Reliability Log tab
 *
 * Same plain-ServiceStore pattern as installStores. `enableStorage` is on
 * so the WIP grid can repopulate offline if needed.
 */
export const purchasingStores: ServiceStoreConfig[] = [
  {
    name: "purchasing-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "purchasing-order-attachments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "purchasing-scratchpads",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "purchasing-vendor-notes",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
];
